export function uploadFiles(inputFile, outputFile) {
  const inputSelected = document.querySelectorAll(inputFile);
  const outputSelected = document.querySelector(outputFile);

  inputSelected.forEach((input) => {
    input.addEventListener('change', function() {

      let size = this.files[0].size;
      let fileName = this.files[0].name;

      if(size < 10485760) {
        if (this.files && this.files[0]) {
          let file = new FileReader();
          file.readAsDataURL(this.files[0]);
          outputSelected.innerText = fileName;
        }
      } else {
        const alert = `<p style="color: red; margin: 0">Tamanho não permitido (Máx.: 10MB)</p>`;
        outputSelected.innerHTML = alert;
      }
    });
  });
}
